import * as yup from "yup";

const getCardBrandByCardNumber = (cardNumber) => {
  // expressões regulares para identificar padrões de números de cartão
  const cardPattern = {
    VISA: /^4[0-9]{12}(?:[0-9]{3})?$/,
    MASTERCARD: /^(5|2)[1-5][0-9]{14}$/,
    AMEX: /^3[47][0-9]{13}$/,
    HIPERCARD: /^(606282\d{10}(\d{3})?)|(3841\d{15})$/,
    ELO: /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/,
  };

  // testar cada expressão regular para encontrar a bandeira do cartão
  return Object.keys(cardPattern).filter((item) => cardNumber.match(cardPattern[item]))[0] || "";
};

const authorizerId = {
  VISA: "1",
  MASTERCARD: "2",
  AMEX: "3",
  HIPERCARD: "5",
  ELO: "41",
};

const submitSchema = yup
  .object()
  .required()
  .shape({
    emailConfirm: yup
      .string()
      .notRequired("É necessário preencher a Confirmação do Email na identificação")
      .test("test", (value, context) => {
        const body = context.from[0].value;
        const email_confirm = value;

        if (body.email !== email_confirm) {
          throw context.createError({
            message: `E-mail de confirmação não corresponde ao email digitado`,
          });
        }
        return true;
      }),
    email: yup.string().required("É necessário preencher o Email na identificação"),
    phone: yup
      .string()
      .matches(/^\(\d{2}\) \d{5}-\d{4}$/, "Número de telefone inválido na identificação")
      .required("É necessário preencher o Telefone na identificação"),
    document_number: yup.string().required("É necessário preencher o número de identificação"),
    identificationName: yup.string().required("É necessário preencher o Nome Completo na identificação"),
    billingState: yup.string().required("É necessário preencher o Estado do endereço de cobrança"),
    billingDistrict: yup.string().required("É necessário preencher o Bairro do endereço de cobrança"),
    billingCity: yup.string().required("É necessário preencher Cidade do endereço de cobrança"),
    billingComplement: yup
      .string()
      .required("É necessário preencher o Complemento do endereço de cobrança"),
    billingAddressNumber: yup
      .string()
      .required("É necessário preencher o Número do endereço de cobrança"),
    billingAddress: yup.string().required("É necessário preencher o Endereço do endereço de cobrança"),
    billingCep: yup.string().required("É necessário preencher o CEP do endereço de cobrança"),
    billingCountry: yup.string().required("Selecione o país do endereço de cobrança"),
    allowTerms: yup.boolean().oneOf([true], "É necessário concordar com os termos de uso"),
    parcels: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (body.paymentForm !== "credCard") return true;

        if (Object.keys(body.parcelValues).length !== 0 && !value) {
          throw context.createError({
            message: `Selecione o número de parcelas`,
          });
        }

        return true;
      }),
    securityCode: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        const authorizer = body.authorizerId;
        if (body.paymentForm !== "credCard") return true;

        const typeBrand = Object.keys(authorizerId).filter((brand) =>
          authorizerId[brand] === authorizer ? brand : ""
        );

        if (authorizer !== "3" && value.length !== 3) {
          throw context.createError({
            message: `Cartões ${typeBrand} devem conter 3 dígitos no CVV`,
          });
        }
        if (authorizer === "3" && value.length !== 4) {
          throw context.createError({
            message: `Cartões AMEX devem conter 4 dígitos no CVV`,
          });
        }

        return true;
      }),
    cardName: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (body.paymentForm !== "credCard") return true;

        if (!value) {
          throw context.createError({
            message: `Digite o nome do titular do cartão`,
          });
        }

        return true;
      }),
    expiryYear: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (body.paymentForm !== "credCard") return true;

        if (!value) {
          throw context.createError({
            message: `Selecione o ano da validade do cartão`,
          });
        }

        return true;
      }),
    expiryMonth: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (body.paymentForm !== "credCard") return true;

        if (!value) {
          throw context.createError({
            message: `Selecione o mês da validade do cartão`,
          });
        }

        return true;
      }),
    cardNumber: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        const authorizer = body.authorizerId;
        if (body.paymentForm !== "credCard") return true;
        // mantém somente os dígitos numéricos do número de cartão
        const cardNumber = value.replace(/(\D)/g, "");

        const typeBrand = Object.keys(authorizerId).filter((brand) =>
          authorizerId[brand] === authorizer ? brand : ""
        );

        if (authorizer === "3" && cardNumber.length !== 15) {
          throw context.createError({
            message: `Cartão AMEX deve conter 15 dígitos`,
          });
        }
        if (authorizer !== "3" && cardNumber.length !== 16) {
          throw context.createError({
            message: `Cartão ${typeBrand} deve conter 16 dígitos`,
          });
        }

        if (!(authorizer === "41" && cardNumber[0] === "4")) {
          const cardBrand = getCardBrandByCardNumber(cardNumber);
          if (authorizerId[cardBrand] !== authorizer) {
            throw context.createError({
              message: `O número do cartão não condiz com a bandeira escolhida`,
            });
          }
        }

        return true;
      }),
    authorizerId: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (body.paymentForm !== "credCard") return true;

        if (!value) {
          throw context.createError({
            message: `Selecione uma bandeira para o número do cartão`,
          });
        }

        return true;
      }),
    paymentForm: yup.string().required("É necessário selecionar uma forma de pagamento"),
    deliveryChoice: yup
      .number()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (!body.shippingType || body.shippingType === "without_shipping_pick_up") return true;

        if (!value && !body.shippingType) {
          throw context.createError({
            message: `Selecione um tipo de entrega`,
          });
        }

        return true;
      }),
    receiverPhone: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (!body.shippingType || body.shippingType === "without_shipping_pick_up") return true;

        const regex = /^\(\d{2}\) \d{5}-\d{4}$/;
        if (!value || !regex.test(value)) {
          throw context.createError({
            message: "Número de telefone do responsável pelo recebimento inválido",
          });
        }

        return true;
      }),
    receiverName: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (!body.shippingType || body.shippingType === "without_shipping_pick_up") return true;

        if (!value) {
          throw context.createError({
            message: `É necessário preencher o Nome do responsável pelo recebimento`,
          });
        }

        return true;
      }),
    deliveryState: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (!body.shippingType || body.shippingType === "without_shipping_pick_up") return true;

        if (!value) {
          throw context.createError({
            message: `É necessário preencher o Estado do endereço de entrega`,
          });
        }

        return true;
      }),
    deliveryCity: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (!body.shippingType || body.shippingType === "without_shipping_pick_up") return true;

        if (!value) {
          throw context.createError({
            message: `É necessário preencher a Cidade do endereço de entrega`,
          });
        }

        return true;
      }),
    deliveryDistrict: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (!body.shippingType || body.shippingType === "without_shipping_pick_up") return true;

        if (!value) {
          throw context.createError({
            message: `É necessário preencher o Bairro do endereço de entrega`,
          });
        }

        return true;
      }),
    deliveryComplement: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (!body.shippingType || body.shippingType === "without_shipping_pick_up") return true;

        if (!value) {
          throw context.createError({
            message: `É necessário preencher o Complemento do endereço de entrega`,
          });
        }

        return true;
      }),
    deliveryAddressNumber: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (!body.shippingType || body.shippingType === "without_shipping_pick_up") return true;

        if (!value) {
          throw context.createError({
            message: `É necessário preencher o Número do endereço de entrega`,
          });
        }

        return true;
      }),
    deliveryAddress: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (!body.shippingType || body.shippingType === "without_shipping_pick_up") return true;

        if (!value) {
          throw context.createError({
            message: `É necessário preencher o Endereço de entrega`,
          });
        }

        return true;
      }),
    deliveryCep: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (!body.shippingType || body.shippingType === "without_shipping_pick_up") return true;

        if (!value) {
          throw context.createError({
            message: `Preencha o CEP do endereço de entrega`,
          });
        }

        return true;
      }),
    deliveryCountry: yup
      .string()
      .notRequired()
      .test("test", (value, context) => {
        const body = context.from[0].value;
        if (!body.shippingType || body.shippingType === "without_shipping_pick_up") return true;

        if (!value) {
          throw context.createError({
            message: `Selecione o pais de entrega`,
          });
        }

        return true;
      }),
  });

export const getBodyRequest = (schemaName, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const schemaRepository = {
        submitSchema: submitSchema,
      };
      const schema = schemaRepository[schemaName] || "";

      if (!schema) throw new Error("Nenhum schema para validação encontrado");
      if (!body || Object.keys(body).length === 0) throw new Error("Nenhum campo está preenchido");
      await schema.strict().validate(body);
      resolve();
    } catch (err) {
      console.log("[validation error]", err);
      console.log("[err.message]", err.message);
      return reject({ response: { data: { message: err.message } } });
    }
  });
};

const customMessage = (e) => {
  console.log(e);
  const {
    type,
    path: content,
    errors: [format],
    params: { type: paramsType, unknown: invalidValues } = {},
  } = e;
  const path = content || "body";
  const pronum = paramsType === "string" ? "uma" : "um";

  const typeMessage = {
    noUnknown: `${type}: ${path} contém um dado inválido [${invalidValues}]`,
    required: `${type}: ${path} ausente`,
    typeError: `${type}: ${path} deve ser ${pronum} ${paramsType}`,
    matches: `${type}: ${path} está em formato inválido [${format}]`,
    test: `${format}`,
  };

  return typeMessage[type];
};
